var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNewChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6210CC",
    fillRule: "evenodd",
    d: "M25.662 11.684a1.573 1.573 0 00-.003-2.225l-.115-.104a1.574 1.574 0 00-2.109.107l-7.621 7.645a5.385 5.385 0 00-1.406 2.475l-.315 1.238.007.047a.18.18 0 00.173.132l1.206-.276a5.404 5.404 0 002.62-1.451l7.563-7.588zm-9.012.369a.75.75 0 00-.75-.75h-3.975l-.166.004a2.921 2.921 0 00-2.76 2.914v8.98l.006.166a2.922 2.922 0 002.92 2.753h9l.166-.005a2.921 2.921 0 002.759-2.914l-.005-3.965a.75.75 0 00-.75-.75h-.745a.75.75 0 00-.75.75v3.965l-.006.092a.675.675 0 01-.67.582h-9l-.09-.006a.674.674 0 01-.584-.668v-8.98l.006-.091a.675.675 0 01.669-.582l3.976-.005a.75.75 0 00.749-.75v-.74z",
    clipRule: "evenodd"
  })));
}

export default SvgIcNewChat;